// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  TableRow,
  TableCell,
  Table,
  Divider,
  Checkbox,
  ListItemText,
  ListItem,
  Chip,
  Stack,
  ListItemAvatar,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

export default function OpsActivityPerformancePage() {
  const pageTitle = "Activities - Team Performance";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);

  const [activity, setActivity] = useState(null);
  const [groupStats, setGroupStats] = useState([]);

  const [selectedGroup, setSelectedGroup] = useState("");
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/ops/activities/${ref}/performance.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setActivity(result.data.data.activity);
            setGroupStats(result.data.data.group_stats);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function getAgentPerfomances(groupRef) {
    let queryParams = {};
    if (groupRef) {
      queryParams["group"] = groupRef;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/ops/activities/${ref}/performance/agents.json`, { params: queryParams })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setAgents(result.data.data.agent_stats);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    let gRef = selectedGroup;
    if (gRef === "ALL") {
      gRef = null;
    }

    getAgentPerfomances(gRef);
  }, [selectedGroup]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={5}>
        <MDBox mt={0} mb={1.5} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                window.history.back();
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox align="right" pr={2}>
            <MDTypography variant="body2" fontSize={12}>
              Team performance
            </MDTypography>
            <MDTypography variant="h6">{activity?.title}</MDTypography>
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card>
                <MDBox>
                  <MDBox p={2}>
                    <MDTypography variant="h6">Group Performance</MDTypography>
                  </MDBox>
                  <MDBox my={2}>
                    <Table>
                      <TableRow>
                        <TableCell>
                          <b>Group</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>Total</b>
                        </TableCell>
                      </TableRow>
                      {groupStats.map((stat) => (
                        <TableRow>
                          <TableCell>{stat.group}</TableCell>
                          <TableCell align="right">{stat.count}</TableCell>
                        </TableRow>
                      ))}
                    </Table>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between">
                      <MDBox>
                        <MDTypography variant="h6">Agent Performance</MDTypography>
                      </MDBox>
                      <MDBox>
                        <MDInput
                          select
                          label="Select Group"
                          onChange={(e) => {
                            setSelectedGroup(e.target.value);
                          }}
                          fullWidth
                          SelectProps={{ style: { padding: "12px 0px" } }}
                          sx={{ minWidth: "120px" }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={selectedGroup}
                        >
                          <MenuItem value="">Select Group</MenuItem>
                          <MenuItem value="ALL">All Agents</MenuItem>
                          {groupStats.map((stat) => (
                            <MenuItem value={stat.reference}>{stat.group}</MenuItem>
                          ))}
                        </MDInput>
                      </MDBox>
                    </MDBox>
                  </MDBox>

                  <MDBox my={2}>
                    <Table>
                      <TableRow>
                        <TableCell>
                          <b>Agent</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>Total</b>
                        </TableCell>
                      </TableRow>
                      {agents.map((stat) => (
                        <TableRow>
                          <TableCell>{stat.agent}</TableCell>
                          <TableCell align="right">{stat.count}</TableCell>
                        </TableRow>
                      ))}
                    </Table>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
